export default __webpack_public_path__ + "static/media/footer_download_app1.0fdfb898.jpeg";